module.exports = __webpack_public_path__ + "media/images/payments/bitpay-fdff12cddc2011045a963c098fd06292.svg";